import StyledLink from './Link'

const Wrapper = StyledLink.withComponent('a')

export default Wrapper
